import PropTypes from "prop-types";
import "./styles.scss";

const DominoLetters = ({ text, size, isConsonant }) => {
  return text ? (
    <div className={"domino-letters " + size + isConsonant}>{text}</div>
  ) : null;
};

DominoLetters.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  isConsonant: PropTypes.string.isRequired,
};

export default DominoLetters;
